<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="shipping-history-detail">
      <Title class="_title" :jpn="t('履歴')" />
      <HistoryHeader />
    </div>
    <div class="shipping-list" v-if="downloadedList && downloadedList.list">
      <div class="shipping-list-detail" v-for="(card,date) in downloadedList.list" :key="date">
        <GreenGradationButton :isHeading="true" class="green-button" :text="`${t('ダウンロード済み一覧')}: ${date}`" />
        <CardList
          :cardList="card"
        />
      </div>
      <BoxPager
          v-if="
            downloadedList &&
            downloadedList.page &&
            downloadedList.page.pages
          "
          class="box-pager"
          :totalPageCount="downloadedList.page.all_page"
          :currentPageCount="downloadedList.page.page"
          :dispBoxCount="downloadedList.page.pages.length"
          :pages="downloadedList.page.pages"
          @handlePagerClick="changeCurrentPageCount"
          @handleSquareBtnClick="changeCurrentPageCount"
        />
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n';
import HistoryHeader from '@/components/molecules/HistoryHeader.vue';
import GreenGradationButton from '@/components/atoms/GreenGradationButton.vue';
import CardList from '@/components/organisms/CardList.vue';
import BoxPager from '@/components/organisms/BoxPager.vue';

export default {
  name: 'DownloadedDetail',
  mixins: [t],

  components: {
    BaseTemplate,
    Title,
    HistoryHeader,
    GreenGradationButton,
    CardList,
    BoxPager,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      downloadedList: 'pending/downloadedList',
    }),
  },

  created() {
    const pageNumber = 1;
    this.$store.dispatch('pending/setDownloadedList', { pageNumber });
  },

  methods: {
    changeCurrentPageCount(pageNumber) {
      this.$store.dispatch('pending/setDownloadedList', { pageNumber });
    },
  },
};
</script>

<style lang="scss" scoped>
.shipping-history-detail{
  position: relative;
  width: 100%;
  max-width: 1000px;
  min-height: 100%;
  padding: 30px 0 0 0;
  margin: 0px auto;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  @media screen and (min-width:767px){
    max-width: 580px;
  }
  @media screen and (min-width:1023px){
    max-width: 1000px;
  }
}
.shipping-list{
  .shipping-list-detail{
    max-width: 900px;
    margin: 0 auto;
    .green-button{
      width: 100%;
      width: auto;
    }
  }
}
</style>
